"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterAltOutlined = void 0;
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
var FilterAltOutlined = function (props) { return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
    react_1.default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 4H21V6.96837L15 12.4368V18.5L9 20V12.4368L3 6.96837V4ZM5 6.03163V6H19V6.03163L13 11.5V16.9384L11 17.4384V11.5L5 6.03163Z" }))); };
exports.FilterAltOutlined = FilterAltOutlined;
